'use client'

import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import FilterDesktop from './filter.desktop'
import FilterMobile from './filter.mobile'

const Filters = () => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  if (isDesktop) {
    return <FilterDesktop />
  } else {
    return <FilterMobile />
  }
}

export default Filters
